import { render, staticRenderFns } from "./GestioneFacile.vue?vue&type=template&id=819c6ba0&"
import script from "./GestioneFacile.vue?vue&type=script&lang=js&"
export * from "./GestioneFacile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports